export const NEWSROOM_BASE_PATH = '/newsroom'
